export default "__VITE_ASSET__Bu79JF6x__"